import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Chip, Typography } from '@material-ui/core';
import AddProductIcon from '../../assets/icons/home/add-icon.svg';
import EditIcon from '../../assets/icons/home/edit-icon.svg';
import InventoryIcon from '../../assets/icons/home/inventory-icon.svg';
import ClientIcon from '../../assets/icons/home/add-client-icon.svg';

// Internal dependencies
import { formatDate, formatNumber, routes } from '../../constants.js/misc';
import { setStoreData } from '../../modules/common';
import { setActiveCollection } from '../../modules/collections';
import { getProductsServiceMobile } from '../../services/products';
import { drawerStyles } from '../../containers/AppContainer/AppContainer.styles';
import {
    HomePageMobileCardContainer,
    HomePageMobileCardIcon,
    HomePageMobileContainer,
    HomePageMobileFilterContainer,
    HomePageMobileOrderButton,
    HomePageDaysContainer,
    HomePageDayAchiveContainer,
} from '../HomePage/HomePage.styles';
import PreviewLinkStore from '../../components/PreviewLinkStore/PreviewLinkStore';
import { colors } from '../../constants.js/colors';
import { functionalOrderIcon as OrderIcon } from '../../assets/icons/home/functional-order-icon';
import { functionalCalendarIcon as CalendarIcon } from '../../assets/icons/home/functional-calendar-icon';
import { functionalCalendarFilledIcon as CalendarFilledIcon } from '../../assets/icons/home/functional-calendar-filled-icon';
import { functionalQuestionMarkIcon as QuestionMarkIcon } from '../../assets/icons/home/functional-question-mark-icon';
import { getWeeklyInsightsService, getDailyMetricsByDateService } from '../../services/store';
import { valueMappingSalesInsights } from '../HomePage/constants';

export const HomePageMobile = ({ storeId, storeData, activeCollection }) => {
    const datePickerRef = useRef(null);

    const { t } = useTranslation();
    const [dataProducts, setDataProducts] = useState([]);
    const [getttingProduct, setGettingProduct] = useState();
    const showLoader = storeData.id ? false : true;
    const classes = drawerStyles();

    const [statusPlan, setStatusplan] = useState(null);
    const [daysToPay, setDaysToPay] = useState(null);
    const [paymentStatus, setPaymentStatus] = useState(null);
    const [isPreviewLinkOpen, setIsPreviewLinkOpen] = useState(false);
    const [salesInsightsData, setSalesInsightsData] = useState(valueMappingSalesInsights);
    const [dailyMetricsData, setDailyMetricsData] = useState({
        total_sales: 0,
        total_orders: 0,
    });
    const [selectedDate, setSelectedDate] = useState('');

    const openPreviewLink = () => {
        setIsPreviewLinkOpen(true);
    };

    const getConsecutiveSales = () => {
        const consecutiveSales = [];
        for (let i = 1; i < salesInsightsData.length; i++) {
            if (salesInsightsData[i - 1].value && salesInsightsData[i].value) {
                consecutiveSales.push([salesInsightsData[i - 1], salesInsightsData[i]]);
            }
        }
        return consecutiveSales.length;
    };

    const handleGetMetrics = async (date) => {
        if (date === 'yesterday') {
            const yesterdayDate = new Date();
            yesterdayDate.setDate(yesterdayDate.getDate() - 1);
            const formattedYesterday = yesterdayDate.toISOString().slice(0, 10);
            await getDailyMetricsByDateService(storeId, formattedYesterday)
                .then(({ data }) => {
                    setDailyMetricsData(data);
                })
                .catch((err) => {
                    setDailyMetricsData({
                        total_sales: 0,
                        total_orders: 0,
                    });
                });
        } else if (date && date !== 'today') {
            // Handle custom date from date picker
            await getDailyMetricsByDateService(storeId, date)
                .then(({ data }) => {
                    setDailyMetricsData(data);
                })
                .catch((err) => {
                    setDailyMetricsData({
                        total_sales: 0,
                        total_orders: 0,
                    });
                });
        } else {
            // Handle "today" or no parameter
            await getDailyMetricsByDateService(storeId)
                .then(({ data }) => {
                    setDailyMetricsData(data);
                })
                .catch((err) => {
                    setDailyMetricsData({
                        total_sales: 0,
                        total_orders: 0,
                    });
                });
        }
    };

    const handleDatePickerClick = () => {
        if (datePickerRef.current) {
            // Force focus first, then click
            datePickerRef.current.focus();
            datePickerRef.current.showPicker?.() || datePickerRef.current.click();
        }
    };

    const handleDateChange = (event) => {
        const selectedDate = event.target.value;
        setSelectedDate(selectedDate);
        // Call your metrics function with the selected date
        handleGetMetrics(selectedDate);
    };

    useEffect(() => {
        setGettingProduct(true);
        getProductsServiceMobile(storeId).then(({ data }) => {
            setGettingProduct(false);
            setDataProducts(data);
        });
        getWeeklyInsightsService(storeId)
            .then(({ data }) => {
                const days = ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Do'];
                const valueMapping = Object.entries(data).map(([key, value], index) => ({
                    label: days[index],
                    value: value,
                    originalLabel: key,
                }));
                setSalesInsightsData(valueMapping);
            })
            .catch((err) => {});
        handleGetMetrics();
    }, [storeId]);

    useEffect(() => {
        if (storeData) {
            if (storeData.store_plan) {
                setStatusplan(storeData.store_plan.store_plan_status_id);
                setDaysToPay(storeData.store_plan.days_to_pay);
                setPaymentStatus(storeData.store_plan.store_plan_payment_status_id);
            }
        }
    }, [storeData]);

    return (
        <HomePageMobileContainer>
            <div>
                <Typography variant="subtitle1" style={{ color: colors.primary.dark }}>
                    Hola, {storeData.name} 👋 ¡Listos para vender hoy!
                </Typography>
                <Typography
                    variant="subtitle2"
                    style={{ fontStyle: 'italic', fontWeight: 400, color: colors.gray.light }}
                >
                    Tu tienda es pequeña, pero tus sueños no. Dios ya vio lo que viene ✨
                </Typography>
            </div>
            <HomePageMobileFilterContainer>
                <Chip
                    clickable
                    label="Hoy"
                    icon={<QuestionMarkIcon />}
                    onClick={() => handleGetMetrics()}
                    style={{ width: '100%' }}
                />
                <Chip
                    clickable
                    label="Ayer"
                    icon={<CalendarFilledIcon />}
                    onClick={() => handleGetMetrics('yesterday')}
                    style={{ width: '100%' }}
                />
                <Chip
                    clickable
                    label={selectedDate ? formatDate(selectedDate) : 'Personal'}
                    icon={<CalendarIcon />}
                    onClick={handleDatePickerClick}
                    style={{ width: '100%' }}
                />

                {/* Hidden date input */}
                <input
                    ref={datePickerRef}
                    type="date"
                    onChange={handleDateChange}
                    style={{
                        position: 'absolute',
                        top: '0',
                        left: '10%',
                        width: '1px',
                        height: '1px',
                        opacity: 0.01,
                        zIndex: -1,
                    }}
                />
            </HomePageMobileFilterContainer>
            <div
                style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '16px',
                }}
            >
                <HomePageMobileCardContainer
                    style={{ flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}
                >
                    <Typography variant="body2">Ventas de hoy</Typography>
                    <Typography
                        variant="h5"
                        style={{ fontWeight: 'bold', color: colors.primary.dark }}
                    >
                        {formatNumber(dailyMetricsData.total_sales, 'COP')}
                    </Typography>
                    {/* <Chip label="Coming soon" color="success" /> */}
                </HomePageMobileCardContainer>
                <HomePageMobileCardContainer
                    style={{ flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}
                >
                    <Typography variant="body2">Pedidos de hoy</Typography>
                    <Typography
                        variant="h5"
                        style={{ fontWeight: 'bold', color: colors.primary.dark }}
                    >
                        {dailyMetricsData.total_orders}
                    </Typography>
                    {/* <Chip label="Coming soon" color="success" /> */}
                </HomePageMobileCardContainer>
            </div>
            <div style={{ textAlign: 'center', width: '100%' }}>
                <Link
                    to={routes.ordersPage}
                    style={{ textDecoration: 'none', color: 'inherit', fontSize: '18px' }}
                >
                    <HomePageMobileOrderButton fullWidth startIcon={<OrderIcon />}>
                        Ver Pedidos
                    </HomePageMobileOrderButton>
                </Link>
                {/* <Typography variant="body2">
                    5 pedidos por responder hoy
                </Typography> */}
            </div>
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
                    gap: '16px',
                    width: '100%',
                }}
            >
                <Link
                    to={routes.createOrder}
                    style={{ textDecoration: 'none', color: 'inherit', display: 'flex' }}
                >
                    <HomePageMobileCardContainer
                        style={{
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '8px',
                        }}
                    >
                        <HomePageMobileCardIcon>
                            <img src={AddProductIcon} />
                        </HomePageMobileCardIcon>
                        <Typography variant="body2">{t('Order.create')}</Typography>
                    </HomePageMobileCardContainer>
                </Link>
                <Link
                    to={routes.editStore}
                    style={{ textDecoration: 'none', color: 'inherit', display: 'flex' }}
                >
                    <HomePageMobileCardContainer
                        style={{
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '8px',
                        }}
                    >
                        <HomePageMobileCardIcon>
                            <img src={EditIcon} />
                        </HomePageMobileCardIcon>
                        <Typography variant="body2">{t('MobileHomepage.edit')}</Typography>
                    </HomePageMobileCardContainer>
                </Link>
                <Link
                    to={routes.clientPage}
                    style={{ textDecoration: 'none', color: 'inherit', display: 'flex' }}
                >
                    <HomePageMobileCardContainer
                        style={{
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '8px',
                        }}
                    >
                        <HomePageMobileCardIcon>
                            <img src={ClientIcon} />
                        </HomePageMobileCardIcon>
                        <Typography variant="body2">{t('ClientPage.addClient')}</Typography>
                    </HomePageMobileCardContainer>
                </Link>
                <Link
                    to={routes.inventoryPage}
                    style={{ textDecoration: 'none', color: 'inherit', display: 'flex' }}
                >
                    <HomePageMobileCardContainer
                        style={{
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '8px',
                        }}
                    >
                        <HomePageMobileCardIcon>
                            <img src={InventoryIcon} />
                        </HomePageMobileCardIcon>
                        <Typography variant="body2">{t('InventoryTitle')}</Typography>
                    </HomePageMobileCardContainer>
                </Link>
            </div>
            <HomePageMobileCardContainer style={{ flexDirection: 'column' }}>
                <Typography variant="body2">Racha de ventas</Typography>
                <Typography variant="caption" style={{ color: colors.gray.alternative }}>
                    ¡Mantén tu meta diaria para seguir la racha!
                </Typography>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        margin: '16px 0',
                    }}
                >
                    {salesInsightsData.map((sale, index) => (
                        <HomePageDaysContainer key={index}>
                            <HomePageDayAchiveContainer
                                style={{
                                    backgroundColor: sale.value && colors.primary.main,
                                    fontWeight: sale.value ? 'bold' : 'normal',
                                }}
                            >
                                {sale.value ? '✓' : sale.label}
                            </HomePageDayAchiveContainer>
                            {sale.label}
                        </HomePageDaysContainer>
                    ))}
                </div>
                <div style={{ textAlign: 'center' }}>
                    <Typography variant="body2">
                        {getConsecutiveSales()} días consecutivos
                    </Typography>
                </div>
            </HomePageMobileCardContainer>
            <div style={{ width: '100%' }}>
                <Typography variant="subtitle1">Productos más vistos</Typography>
                <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '8px',
                    }}
                >
                    <HomePageMobileCardContainer>Coming soon</HomePageMobileCardContainer>
                    <HomePageMobileCardContainer>Coming soon</HomePageMobileCardContainer>
                    <HomePageMobileCardContainer>Coming soon</HomePageMobileCardContainer>
                </div>
            </div>
            <PreviewLinkStore
                open={isPreviewLinkOpen}
                dataStore={storeData}
                storeId={storeData.id}
                onClose={() => setIsPreviewLinkOpen(false)}
                title={t('PreviewLink.title')}
                message={t('PreviewLink.subtitle')}
            />
        </HomePageMobileContainer>
    );
};

const mapStateToProps = ({ auth, common, collections }) => ({
    storeId: auth.storeId,
    storeData: common.storeData,
    activeCollection: collections.activeCollection,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setStoreData,
            setActiveCollection,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(HomePageMobile);
